enum PostingPublicValues {
  INTERNAL = "internal",
  MARKETPLACE = "marketplace",
}

export default PostingPublicValues;
